import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useFeatureFlags } from './FeatureFlagsContext';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * An HOC for using feature flags in class components.
 * If the component has a prop with the same name as a feature flag, the prop will override
 * the feature flag.
 */
export function withFeatureFlags(Component) {
  const WrappedComponent = props => {
    const featureFlags = useFeatureFlags();
    return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, featureFlags), props));
  };
  WrappedComponent.displayName = "withFeatureFlags(".concat(Component.displayName, ")");
  return WrappedComponent;
}